module.exports = __webpack_public_path__ + "res/rumba.mp3";